import { Profile } from '@common'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { api } from '@/api'
import { AppThunk } from '@/store'

import { onOverlaySuccess } from '../overlay/overlaySlice'

export enum LOGIN_STATUS {
  LOGGED_OUT = 'LOGGED_OUT',
  CONFIRM_LOGIN = 'CONFIRM_LOGIN',
  LOGGED_IN = 'LOGGED_IN',
  LOGIN_FAILED = 'LOGIN_FAILED',
}

export interface UserState {
  profile: Profile['profile'] | null
  inventory: Profile['inventory'] | null
  email: string | null
  token: string | null
  loginStatus: LOGIN_STATUS
  error: string | null
}

const initialState: UserState = {
  profile: null,
  inventory: null,
  email: '',
  token: null,
  loginStatus: LOGIN_STATUS.LOGGED_OUT,
  error: null,
} as const

export const logOut: AppThunk = (dispatch) => {
  dispatch(resetUser())
  dispatch(onOverlaySuccess)
  window.location.reload()
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setEmail: (state: UserState, action: PayloadAction<string>) => {
      state.email = action.payload
    },
    setLoginStatus: (state: UserState, action: PayloadAction<LOGIN_STATUS>) => {
      state.error = null
      state.loginStatus = action.payload
    },
    loginError: (state: UserState, action: PayloadAction<{ error: string }>) => {
      state.error = action.payload.error
    },
    resetUser: () => {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.login.matchPending, (state) => {
      state.error = null
    })
    builder.addMatcher(api.endpoints.login.matchFulfilled, (state) => {
      state.loginStatus = LOGIN_STATUS.CONFIRM_LOGIN
    })
    builder.addMatcher(api.endpoints.loginConfirm.matchFulfilled, (state, { payload }) => {
      state.token = payload.token
      state.email = null
      state.loginStatus = LOGIN_STATUS.LOGGED_IN
    })
    builder.addMatcher(api.endpoints.fetchProfile.matchFulfilled, (state, { payload }) => {
      state.profile = payload.profile
      state.inventory = payload.inventory
      state.loginStatus = LOGIN_STATUS.LOGGED_IN
    })
    builder.addMatcher(api.endpoints.loginConfirm.matchRejected, (state) => {
      state.loginStatus = LOGIN_STATUS.LOGIN_FAILED
      state.error = 'confirmation rejected'
    })
  },
})

export const { setEmail, setLoginStatus, resetUser } = userSlice.actions

export default userSlice.reducer
